<!-- <h2 class="pb-4 text-lg font-bold">Position and Weather</h2> -->
<div class="flex flex-col gap-y-2">
  @let vm = offshoreReportStore.vm();

  @if (vm.isSectionVisible('positionAndWeather', 'positionAndLogistics')) {
    <re-position-and-logistics
      id="positionAndLogistics"
      class="flex flex-col gap-y-2"
    />
    <p-divider />
  }
  @if (vm.isSectionVisible('positionAndWeather', 'observation')) {
    <re-observation
      id="observation"
      class="flex flex-col gap-y-2"
    />
    <p-divider />
  }
  @if (vm.isSectionVisible('positionAndWeather', 'wind')) {
    <re-wind
      id="wind"
      class="flex flex-col gap-y-2"
    />
    <p-divider />
  }

  @if (vm.isSectionVisible('positionAndWeather', 'speedAndDistance')) {
    <re-speed-and-distance
      id="speedAndDistance"
      class="flex flex-col gap-y-2"
    />
    <p-divider />
  }
  @if (vm.isSectionVisible('positionAndWeather', 'currentsAndSeaWater')) {
    <re-currents-and-sea-water
      id="currentsAndSeaWater"
      class="flex flex-col gap-y-2"
    />
    <p-divider />
  }
  @if (vm.isSectionVisible('positionAndWeather', 'shipPosition')) {
    <re-ship-position id="shipPosition" />
    <p-divider />
  }
  @if (vm.isSectionVisible('positionAndWeather', 'weatherEffect')) {
    <re-weather-effect
      id="weatherEffect"
      class="flex justify-center"
    />
    <p-divider />
  }
  @if (weatherStore.dynamicSection()) {
    <re-dynamic-form
      tabId="positionAndWeather"
      [events]="events"
      [formConfig]="
        offshoreReportStore.formConfig()?.tabs?.['positionAndWeather']
          ?.customFields ?? []
      "
      [storeSectionState]="weatherStore.dynamicSection()"
      class="flex flex-col gap-y-2"
    ></re-dynamic-form>
  }
</div>
